import * as React from "react";
import {InnerFrame} from "./styled";
import CustomerList from "./customerList";
import { Footer } from "./footer";
import styled from "styled-components";

export const Frame = styled.div`
  border-radius: 4px;
  padding: 25px;
  .customerList{
    justify-content: left;
    margin-bottom: 25px;
    div{
      justify-content: left;
    }
  }
  h2{
    margin-right: 5px;
  }
  ${props =>
  `
    background: ${props.theme.colors.backgroundPrimary};
    border: ${props.theme.colors.border};
  `
}
`;


const CustomerFrame = () => {

  return(
    <Frame>
      <InnerFrame>
        <CustomerList/>
      </InnerFrame>
      <Footer/>
    </Frame>
  )
}

export default CustomerFrame;
